import { Fragment } from 'react';
import { type CustomerProduct } from '@recargas-dominicanas/core/types';
import { Cell } from '@recargas-dominicanas/core/components';
import { TableRow } from '@recargas-dominicanas/core/components';
import { CellImage } from '@recargas-dominicanas/core/components';
import { formatCurrency } from '@recargas-dominicanas/core/utils';
import { type Style } from './product-item.module.css';

interface Props {
  customerProduct: CustomerProduct,
  style?: Style
}

export function ProductItem(props: Props) {

  const { customerProduct } = props;
  
  return (
    <Fragment>
      <TableRow>
        <CellImage src={customerProduct.product.image}/>
        <Cell weight='medium' text={customerProduct.product.name}/>
        <Cell text={customerProduct.product.type}/>
        {customerProduct.product.profitType === 'percent'
          ? <Cell weight='bold' color='green' text={`${customerProduct.profit}%`}/>
          : <Cell weight='bold' color='green' text={formatCurrency(customerProduct.profit)}/>
        }
      </TableRow>
    </Fragment>
  );
}
